export default __webpack_public_path__ + "static/media/right-column-bottom-left-image.9bdb4393.jpg";